// extracted by mini-css-extract-plugin
export default {"root":"Status_root__sv4yD","state0":"Status_state0__8AnmN","state1":"Status_state1__ZGp3w","state2":"Status_state2__RauDE"};